import React from "react";
const SvgFilterEditDsk = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      fill="none"
      stroke="#697684"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1 15l1.217-3.652L12.565 1 15 3.435 4.652 13.783 1 15zm9.74-12.174l2.434 2.435"
    />
  </svg>
);
export default SvgFilterEditDsk;
